"use client";

import { paymentConfig } from "../payment-config";

// Payment widget callback types
interface PaymentOptions {
  [key: string]: unknown;
}

interface PaymentResult {
  status?: string;
  transactionId?: string;
  [key: string]: unknown;
}

// Declare TiptopPay types on window
declare global {
  interface Window {
    tiptop?: {
      Widget: new (config: { language: string }) => TiptopWidget;
    };
  }
}

interface TiptopWidget {
  pay: (
    action: string,
    options: PaymentWidgetOptions,
    callbacks: PaymentCallbacks
  ) => void;
}

interface PaymentWidgetOptions {
  publicId: string;
  description: string;
  amount: number;
  currency: string;
  skin: string;
  autoClose: number;
  data: {
    AuthId: string;
    Email: string;
    TokenCount: number;
  };
  invoiceId: string;
}

interface PaymentCallbacks {
  onSuccess?: (options?: PaymentOptions) => void;
  onFail?: (reason?: string | Error, options?: PaymentOptions) => void;
  onComplete?: (paymentResult?: PaymentResult, options?: PaymentOptions) => void;
}

export class TiptopPaymentWidget {
  private widget: TiptopWidget;

  constructor() {
    if (!paymentConfig.tiptoppay.publicId) {
      throw new Error("TiptopPay public ID is not configured");
    }

    // Check if TiptopPay script is loaded
    if (typeof window === "undefined" || !window.tiptop) {
      throw new Error(
        "TiptopPay script is not loaded. Please ensure the script is included in your HTML."
      );
    }

    this.widget = new window.tiptop.Widget({ language: "en-US" });
  }

  public initiatePayment(
    tokenCount: number,
    amount: number,
    currency: string,
    userId: string,
    userEmail: string,
    callbacks: PaymentCallbacks
  ) {
    const options: PaymentWidgetOptions = {
      publicId: paymentConfig.tiptoppay.publicId,
      description: `Tokens amount: ${tokenCount}`,
      amount: Math.round(amount),
      currency: currency,
      skin: "mini",
      autoClose: 3,
      data: {
        AuthId: userId,
        Email: userEmail,
        TokenCount: tokenCount,
      },
      invoiceId: crypto.randomUUID(),
    };

    this.widget.pay("charge", options, callbacks);
  }
}
